import { createContext, useState } from 'react';

export const SubscriptionContext = createContext();

export const SubscriptionProvider = ({ children }) => {
  const [isSubscribing, setIsSubscribing] = useState(false);
  
  return (
    <SubscriptionContext.Provider value={{ isSubscribing, setIsSubscribing }}>
      {children}
    </SubscriptionContext.Provider>
  )
}
